<template>
  <div id="app">
    <Header v-if="!shouldHideLayout" />

    <HomeAnnouncement v-if="$route.name !== 'ViewTicket' && !shouldHideLayout" />
    <main>
      <router-view />
    </main>
    <VendorFooter v-if="shouldHideLayout && isExternalSite "  />
    <Footer v-if="($route.name !== 'ticket' && $route.name !== 'payment' && $route.name !== 'international-ticket-listing') && !shouldHideLayout" />
    
    <!-- PWA Install Prompt - Disabled for now -->
    <!-- <PWAInstallPrompt /> -->
  </div>
</template>

<script>
const Header = () => import('@/components/General/Header')
const HomeAnnouncement = () => import('@/components/General/HomeAnnouncement')
const Footer = () => import('@/components/General/Footer')
const VendorFooter = () => import('@/components/General/VendorFooter')
// const PWAInstallPrompt = () => import('@/components/General/PWAInstallPrompt')
import { mapGetters } from 'vuex'
import localStorageServices from "@/common/jwt.services"

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    HomeAnnouncement,
    VendorFooter
    // PWAInstallPrompt
  },
  computed: {
    ...mapGetters({
      isSpark: 'isSpark',
      isExternalSite: 'isExternalSite'
    }),
    shouldHideLayout() {
      const vendorIdExists = this.$route.query.vendorId;
      const sparkExists = this.$route.query.customeremail;
      const isEventRoute = ['event', 'tickets', 'ticket', 'payment', 'event-payment-confirmation'].includes(this.$route.name);
      
      return this.isSpark || this.isExternalSite || (isEventRoute && vendorIdExists) || sparkExists;
    }
  },
  methods: {
    blockBackButtonIfNeeded() {
    const eventRoutes = ['event', 'tickets', 'ticket', 'payment', 'event-payment-confirmation'];
    const isEventRoute = eventRoutes.includes(this.$route.name);
    const vendorId = JSON.parse(localStorageServices.getObject("vendorId"));
    const externalSite = localStorageServices.getObject("externalSite");

    if (isEventRoute && vendorId && externalSite) {
      // Push current state to block back
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = () => {
        // 👇 Instead of going back, redirect to event page
        this.$router.replace({
          name: "event",
          params: { eventId: this.$route.params.slug },
          query: { vendorId }
        });
      };
    } else {
      // Reset default back behavior
      window.onpopstate = null;
    }
  },
    toggleSuperChatWidget() {
  const shouldHideWidget = this.isSpark || this.isExternalSite || this.$route.name === 'international-ticket-listing';
  const observer = new MutationObserver(() => {
    const widget = document.querySelector("#superchat-widget");
    if (widget) {
      widget.style.display = shouldHideWidget ? 'none' : '';
      observer.disconnect(); // stop observing once found
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
},
handleExternalSiteLogic() {
  setTimeout(() => {
    const vendorIdExists = this.$route.query.vendorId;
    const isEventRoute = ['event', 'tickets', 'ticket', 'payment', 'event-payment-confirmation'].includes(this.$route.name);
    if (!vendorIdExists && !isEventRoute) {
      if (this.isExternalSite) {
        this.$store.dispatch('updateExternalSite', false);
        localStorageServices.destroyObject("externalSite");
        localStorageServices.destroyObject("vendorId");
      }
    }
  }, 2000); // 500ms delay

}
  },
  mounted() {
    this.toggleSuperChatWidget();
    this.handleExternalSiteLogic();
    this.blockBackButtonIfNeeded();
  },
  watch: {
    isSpark() {
      this.toggleSuperChatWidget();
    },
    isExternalSite() {
      this.toggleSuperChatWidget();
    },
    '$route'(to) {
      // Handle external site logic on route change
      this.handleExternalSiteLogic();
      this.blockBackButtonIfNeeded();
    }
    
  }
}
</script>

<style>
.no-display {
  display: none !important;
}
</style>